import { SimConstants } from "@highmarch/domain";

/**
 * When a healer plays its cast (`attack`) for the sim's heals. The sim emits EnemyHealed every tick for every hurt ally
 * in reach (DESIGN §5: a heal per second, dealt a twentieth a tick), its amount floored to whole HP (often 0), so
 * casting on each one played the clip back to back. A healer casts on any heal (a heal floored to 0 HP is still a real
 * heal: allies under ~667 max HP only ever show 0, and the healer must still be seen working on early levels), but not
 * again until CAST_EVERY of its cast clip's length has passed (the clip, then a breath before the next). Pure (no GL),
 * so test/healerCast.test.ts pins it.
 */
export const CAST_EVERY = 2;

export class HealerCasts {
  /** The tick each healer (by sim id) last cast. */
  private readonly last = new Map<number, number>();

  /** True when healer `id`, whose cast clip runs `clipSeconds`, should cast for a heal at sim `tick` (`amount`, whole HP, may floor to 0). */
  cast(id: number, amount: number, tick: number, clipSeconds: number): boolean {
    if (amount < 0 || clipSeconds <= 0) return false;
    const at = this.last.get(id);
    if (at !== undefined && tick - at < CAST_EVERY * clipSeconds * SimConstants.TicksPerSecond) return false;
    this.last.set(id, tick);
    return true;
  }

  /** The healer has gone (dead, leaked or released): its slot id may be reused. */
  forget(id: number): void { this.last.delete(id); }
}
